import React, { useRef } from "react";
import { ArrowRight, ArrowLeft, ArrowUpRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import Container from "Components/Container/Container";

// swiper
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const BrandSlider = ({ data }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  // Create a reversed copy of the data
  const reversedData = [...data].reverse();

  return (
    <div className="f gap-x-12 mt-10 relative lg:w-1/2 mx-auto">
      <button
        ref={nextRef}
        className="slider-arrow absolute top-6 right-10 lg:top-1/2 lg:-translate-y-1/2 lg:-right-14 z-[100] rounded-full flex items-center justify-center bg-black text-2xl text-black bg-light p-1"
      >
        <ArrowRight />
      </button>

      <button
        ref={prevRef}
        className="slider-arrow absolute top-6 left-10 lg:top-1/2 lg:-translate-y-1/2 lg:-left-14 z-[100] bg-light flex items-center justify-center bg-black text-2xl text-black rounded-full p-1"
      >
        <ArrowLeft />
      </button>

      <Swiper
        spaceBetween={6}
        slidesPerView={1}
        slidesPerGroup={1}
        navigation={{
          clickable: true,
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        modules={[Autoplay, Navigation]}
        className=" "
        speed={1000}
      >
        {reversedData.map(({ logo, description, slug }, index) => (
          <SwiperSlide key={index}>
            <div className={`text-white text-center`}>
              <img
                className="w-[8rem] mx-auto object-contain"
                src={logo}
                alt=""
              />

              <div
                className="mt-4"
                dangerouslySetInnerHTML={{ __html: description }}
              />

              <Link
                to={`/products/${slug}`}
                state={{ isBrand: true }}
                className="text-font mt-10 block hover:underline flex items-center gap-x-1 justifty-center mx-auto w-max"
              >
                <ArrowUpRight size={28} />
                More details
              </Link>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default BrandSlider;
